const constants = {
  repeatEveryYearOptions: [
    {
      value: true,
      text: 'Holiday Repeats Every Year',
      icon: ''
    },
    {
      value: false,
      text: 'Holiday Does Not Repeat Every Year',
      icon: ''
    }
  ],
  companyHolidayOptions: [
    { value: true, text: 'Y', icon: '' },
    { value: false, text: 'N', icon: '' }
  ],
  MAX_HOLIDAY_LENGTH: 150,
  LABEL: {
    COMPANY_HOLIDAY: 'Company Holiday'
  },
  MESSAGE: {
    TERMINAL_SELECT_CUSTOMER: "Holiday will be applicable only for customers in selected terminal(s).",
    TERMINAL_SELECT_GLOBAL: " Ensure the holiday visibility across all terminals by refraining from selecting any specific terminal.",
    HOLIDAY_VALIDATION_INPROGRESS: "Please wait, holiday validation check is in progress...",
    NO_ASSIGNED_CUSTOMER: "Note: No customers assigned to this holiday yet",
    CUSTOMER_ASSIGNED_DELETE: "Please unassign customers from this holiday before attempting deletion.",
    CUSTOMER_ASSIGNED_EDIT: "Please unassign customers from this holiday before attempting edit.",
    UNASSIGNED_HOLIDAY_WARNING: "Please note this holiday is being shared with terminals beyond your accessible list. Removing the holiday will result in its removal for all terminals."
  }
};

export { constants };
